<div class="popup-container" *ngIf="isVisible">
  <div class="popup">
    <svg
      class="info-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 25 25"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="11"></line>
      <line x1="12" y1="8" x2="12" y2="8" />
    </svg>
    <div class="instruction-div">
      <p class="instruction-text">
        {{ instructionText || "Error occurred while processing request." }}
      </p>
    </div>
    <div>
      <button
        type="button"
        class="okay-button btn btn-primary ac-btn-primary"
        (click)="closePopup()"
      >
        Okay
      </button>
    </div>
  </div>
</div>
